export default "__VITE_ASSET__BNmnZXvt__"